/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon20Regular = forwardRef('ArrowShapeTriangleAUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.38 14a1.35 1.35 0 0 1-1.118-2.107l4.62-6.829a1.35 1.35 0 0 1 2.236 0l4.62 6.83A1.35 1.35 0 0 1 14.62 14H5.38Zm.283-1.5h8.674L10 6.088 5.663 12.5Z" })));
});
